import { Reveal } from "./Reveal";
import { IMAGES } from "@/lib/content";

export const Gallery = () => (
  <section data-testid="gallery" className="bg-[#EFECE7] py-24 md:py-40 overflow-hidden">
    <div className="max-w-[1500px] mx-auto px-6 md:px-12">
      <Reveal>
        <span className="eyebrow">Selected work</span>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4 max-w-3xl leading-[1.02]">
          A few rooms we've had the privilege to furnish.
        </h2>
      </Reveal>

      <div className="grid grid-cols-2 md:grid-cols-12 gap-4 md:gap-8 mt-16 md:mt-24 items-end">
        <Reveal className="col-span-2 md:col-span-5">
          <div className="relative overflow-hidden aspect-[4/5] border border-[#E5E0D8]">
            <img src={IMAGES.bedroom} alt="Bespoke bedroom" className="img-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.1} className="col-span-1 md:col-span-4 md:mb-24">
          <div className="relative overflow-hidden aspect-square border border-[#E5E0D8]">
            <img src={IMAGES.wood} alt="Timber detail" className="img-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.2} className="col-span-1 md:col-span-3">
          <div className="relative overflow-hidden aspect-[3/4] border border-[#E5E0D8]">
            <img src={IMAGES.craft2} alt="Hand finishing" className="img-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.1} className="col-span-2 md:col-span-7 md:mt-8">
          <div className="relative overflow-hidden aspect-[16/10] border border-[#E5E0D8]">
            <img src={IMAGES.dining} alt="Dining commission" className="img-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.2} className="col-span-2 md:col-span-5 md:mt-8">
          <div className="relative overflow-hidden aspect-[16/10] border border-[#E5E0D8]">
            <img src={IMAGES.office} alt="Commercial office fit-out" className="img-cover" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
